
















































import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import BaseAvatar from "@/components/BaseAvatar";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "ModalSwitchAccount",
  components: { ListItem, BaseAvatar, BaseIcon, BaseSpinner, EmptyContent, BaseConfirm },
  props: {
    show: { type: Boolean, default: false },
    users: { type: Array as () => UserPublicData[], required: true },
    creatorsMessages: { type: Object as () => Record<string, number>, required: true },
    loadingUserId: { type: String, required: true },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const { authUser } = useAuthUser();
    const closeModal = () => emit("close");
    const checkCurrentUser = (userId: string) => userId === authUser.value?.id;
    const handleClick = (user: UserPublicData) => !checkCurrentUser(user.id) && emit("accountClick", user);

    return {
      closeModal,
      handleClick,
      checkCurrentUser,
    };
  },
});
